import { string } from "prop-types";

export default {
  name: string,
};
